import ExtractRfpDocuments from "./ExtractRfpDocuments";
export default ExtractRfpDocuments;